import React from 'react';
import { createElementClassName } from './utilityFooterLayoutStyles';

type Props = {
  copyrightNode: React.ReactNode;
  linksNode: React.ReactNode;
};

export const UtilityFooterLayout: React.FC<Props> = (props) => {
  const { copyrightNode, linksNode } = props;

  return (
    <div className={createElementClassName('wrapper')}>
      <div className={createElementClassName('copyrightSlot')}>
        {copyrightNode}
      </div>
      <div className={createElementClassName('linksSlot')}>{linksNode}</div>
    </div>
  );
};
